module.exports = {
      id: "double-arrow-usage",
      viewBox: "0 0 21.133 19.508",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#double-arrow",
      toString: function () {
        return this.url;
      }
    }